// utils/options.js
export const titles = ["MR.", "MRS.", "MS.", "DR.", "PROF.", "REV.", "ENG.", "HON.", "SIR.", "LADY.", "OTHER"];

export const genders = ["Male", "Female", "Other"];
export const maritalStatuses = ["Married", "Single", "Widow", "Divorce", "Widower"];

export const residenceHalls = [ 
  "LEGON HALL",
  "AKUAFO HALL",
  "COMMONWEALTH HALL",
  "VOLTA HALL",
  "MENSAH SARBAH HALL",
  "VALCO TRUST HOSTEL",
  "INTERNATIONAL STUDENTS’ HOSTEL",
  "SSNIT HOSTELS ",
  "JUBILEE HOSTEL",
  "DR. HILLA LIMANN HALL",
  "TF",
  "PENTAGON",
   "DIASPORA",
  "EVANDY HALL",
   "OTHER HOSTELS",
];

export const associateSchools = [
  "UNIVERSITY OF GHANA",       
  "UNIVERSITY OF CAPE COAST",  
  "UNIVERSITY OF EDUCATION, WINNEBA", 
  "KWAME NKRUMAH UNIVERSITY OF SCIENCE AND TECHNOLOGY", 
  "UNIVERSITY OF DEVELOPMENT STUDIES", 
  "UNIVERSITY OF ENERGY AND NATURAL RESOURCES", 
  "UNIVERSITY OF MINES AND TECHNOLOGY", 
  "UNIVERSITY OF PROFESSIONAL STUDIES, ACCRA", 
  "GHANA INSTITUTE OF MANAGEMENT AND PUBLIC ADMINISTRATION", 
  "CENTRAL UNIVERSITY",
  "MOUNT CARMEL UNIVERSITY",
  "VALLEY VIEW UNIVERSITY",
  "WISCONSIN INTERNATIONAL UNIVERSITY COLLEGE – GHANA",
  "GHANA TECHNOLOGICAL UNIVERSITY COLLEGE",
  "ANGEL ACADEMY UNIVERSITY",
  "TRINITY THEOLOGICAL SEMINARY",
  "GHANA CHRISTIAN UNIVERSITY COLLEGE",
  "OTHER UNIVERSITIES",


];

export const academicStatuses = [
  "Undergraduate",
  "Graduate / Master's",
  "Postgraduate / PhD",
  "Diploma",
  "Associate Degree",
  "Certificate",
  "Alumni / Completed",
  "Other",
];

export const professionalStatuses = [
  "Employed - Private Sector",
  "Employed - Public Sector / Government",
  "Self-employed / Entrepreneur",
  "Consultant / Freelancer",
  "Unemployed / Seeking Opportunities",
  "Student",
  "Retired",
  "Other",
];

export const getYearOptions = (yearsBack = 50) => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: yearsBack + 1 }, (_, i) => currentYear - i);
};
